import Keycloak from "keycloak-js";

export const PREVIEW_MODE = import.meta.env.VITE_PUBLIC_PREVIEW === "true";

const url = import.meta.env.VITE_KEYCLOAK_URL;
const realm = import.meta.env.VITE_KEYCLOAK_REALM;
const clientId = import.meta.env.VITE_KEYCLOAK_CLIENT_ID;

if (!PREVIEW_MODE && (!url || !realm || !clientId)) {
  throw new Error(
    "Missing Keycloak config: VITE_KEYCLOAK_URL / VITE_KEYCLOAK_REALM / VITE_KEYCLOAK_CLIENT_ID must be set at build time.",
  );
}

export const keycloak = PREVIEW_MODE
  ? (undefined as unknown as Keycloak)
  : new Keycloak({ url: url!, realm: realm!, clientId: clientId! });

let initPromise: Promise<boolean> | null = null;

export function initKeycloak(): Promise<boolean> {
  if (PREVIEW_MODE) return Promise.resolve(true);
  if (!initPromise) {
    initPromise = keycloak.init({
      onLoad: "login-required",
      checkLoginIframe: false,
      pkceMethod: "S256",
      enableLogging: import.meta.env.DEV,
    });
  }
  return initPromise;
}

export function logout(): void {
  if (PREVIEW_MODE) return;
  void keycloak.logout({ redirectUri: window.location.origin });
}

export function getEmail(): string | undefined {
  if (PREVIEW_MODE) return undefined;
  const token = keycloak.tokenParsed as { email?: string } | undefined;
  return token?.email;
}

export function getDisplayName(): string {
  if (PREVIEW_MODE) return "Preview mode";
  const token = keycloak.tokenParsed as
    | { name?: string; preferred_username?: string; email?: string }
    | undefined;
  return token?.name ?? token?.preferred_username ?? token?.email ?? "Signed in";
}
